import { AuthProvider } from "#contexts/authContext.jsx";
import "react-phone-input-2/lib/style.css";
import { ErrorBoundary } from "react-error-boundary";
import Router from "./routes/router";
import { QueryClient, QueryClientProvider } from "react-query";
import { Toaster } from "react-hot-toast";
import { CustomErrorBoundary } from "#UI";
import { Provider } from "react-redux";
import { store, persister } from "#redux/store.js";
import { LanguageProvider } from "#contexts/languageContext.jsx";
import "react-datepicker/dist/react-datepicker.css";
import { AppProvider } from "#contexts/sidebarContext.jsx";
import { PersistGate } from "redux-persist/integration/react";

function App() {
  const queryClient = new QueryClient();
  function fallbackRender({ error, resetErrorBoundary }) {
    return <CustomErrorBoundary error={error} />;
  }

  return (
    <ErrorBoundary fallbackRender={fallbackRender}>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <PersistGate loading={<p>Loading...</p>} persistor={persister}>
            <LanguageProvider>
              <AuthProvider>
                <AppProvider>
                  <Router />
                  <Toaster />
                </AppProvider>
              </AuthProvider>
            </LanguageProvider>
          </PersistGate>
        </Provider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
